// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__fVJLd","content":"style_content__10xgI","calculator":"style_calculator__Uyxtg","title":"style_title__EmpRA","button":"style_button__lAIUd"};